import { cn } from '@/core/utils/common'

const SIZE = {
  /** 홈 피드 카드 · 랭킹 줄 */
  md: 'text-c12 over10:text-c13',
  /** 좁은 레일 카드 */
  sm: 'text-c11 over10:text-c12',
}

/**
 * 작품 태그 한 줄(#태그 #태그) — 상품 목록은 ProductMeta 가 이것을 쓴다(2026-10-07 원칙: 상품 목록엔 어디든 태그). 한 줄로 자르고, 태그가 없으면 그리지 않는다.
 * 글자 크기는 size 로 고른다 — cn 이 클래스를 병합하지 않아 className 으로 text-* 를 덮으면 둘 다 남는다. className 은 여백용.
 */
export default function TagLine({
  tags,
  max = 4,
  size = 'md',
  className = 'mt-1',
}: {
  tags?: string[]
  max?: number
  size?: keyof typeof SIZE
  className?: string
}) {
  if (!tags?.length) return null
  return (
    <span className={cn('block truncate text-t3', SIZE[size], className)}>
      {tags
        .slice(0, max)
        .map((t) => `#${t}`)
        .join(' ')}
    </span>
  )
}
